import React, { useState } from "react";
import cs from "classnames";
import TagSelect from "../tagSelect";
import Scrollbars from "react-custom-scrollbars";
import { isFromHuaweiCustom, isSupportWebp, thumbnail } from "@/utils";
import { Popover } from "antd";
import "antd/es/popover/style/css";
import { BTN_UUID } from "@/constants/workbench";
import {
  InitPPTResponseTagSelect,
  TemplateSelectItem,
} from "@/services/workbench/types";
import { useGetUserInfo } from "@/hooks/useUserHelper";
import { statTrack } from "@/utils/mtstat";
import Image from "next/image";
import styles from "./index.module.css";
import dynamic from "next/dynamic";
import LazyImage from "@/components/lazyImage";
import { SCENE } from "@/constants";
const GenBtn = dynamic(
  () => import("@meitu/xdesign-widgets/dist/meidouInfo/compoments/genBtn"),
  {
    ssr: false,
  }
);

interface TemplateSelectProps {
  tagSelect: InitPPTResponseTagSelect[] | TemplateSelectItem[];
  activeTag: string;
  setActiveTag: React.Dispatch<React.SetStateAction<string>>;
  activeTemplate: string;
  templateList: TemplateSelectItem["templates"];
  setActiveTemplate: React.Dispatch<React.SetStateAction<string>>;
  onGen?: () => void;
  handleErrorMessage?: (msg: string) => void;
}

interface ItemPopoverProps {
  v: {
    height: number;
    width: number;
    json_url: string;
    template_id: string;
    url: string;
    is_new?: boolean;
    full_preview?: string;
    corner_mark_url?: string;
    display_pic?: string;
  };
  activeTemplate: string;
  setActiveTemplate: React.Dispatch<React.SetStateAction<string>>;
  supportWebp: boolean;
}

const ItemPopover = (props: ItemPopoverProps) => {
  const { v, activeTemplate, setActiveTemplate, supportWebp } = props;
  const [open, setOpen] = useState(false);
  return (
    <Popover
      overlayClassName={styles.templateItemPopoverOverlay}
      destroyTooltipOnHide={true}
      placement="rightTop"
      showArrow={false}
      align={{
        offset: [4, -16],
      }}
      open={open}
      content={
        <div className={styles.templateItemPopover}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <LazyImage
            src={v.full_preview || v.url}
            loading="lazy"
            alt=""
            width={168}
            height={v.full_preview ? 190 : v.width < v.height ? 190 : 95}
          />
        </div>
      }
      trigger="hover"
    >
      <div
        className={cs({
          [styles.templateItem]: true,
          [styles.templateItemActive]: activeTemplate === v.template_id,
        })}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <LazyImage
          className={styles.img}
          key={v.template_id}
          loading="lazy"
          // width={212}
          // height={120}
          src={v.display_pic || v.url}
          alt=""
          onClick={() => {
            if (v.template_id === activeTemplate) return;
            statTrack("tools_click_ppt_home", {
              click_type: "pick_template",
            });
            setActiveTemplate(v.template_id);
          }}
        />
        {v.corner_mark_url && (
          // eslint-disable-next-line @next/next/no-img-element
          <img className={styles.newTagIcon} src={v.corner_mark_url} alt="" />
        )}
        {/* <div
          className={styles.img}
          key={v.template_id}
          style={{
            backgroundImage: `url(${
              supportWebp && !v.display_pic?.includes("webp")
                ? thumbnail(v.url, 440, 100)
                : v.display_pic
            })`,
          }}
          onClick={() => {
            if (v.template_id === activeTemplate) return;
            statTrack("tools_click_ppt_home", {
              click_type: "pick_template",
            });
            setActiveTemplate(v.template_id);
          }}
        >
          {v.corner_mark_url && (
            // eslint-disable-next-line @next/next/no-img-element
            <img className={styles.newTagIcon} src={v.corner_mark_url} alt="" />
          )}
        </div> */}
      </div>
    </Popover>
  );
};

const TemplateSelect = (props: TemplateSelectProps) => {
  const {
    tagSelect,
    activeTag,
    setActiveTag,
    activeTemplate,
    templateList,
    setActiveTemplate,
    onGen,
    handleErrorMessage,
  } = props;
  const userInfo = useGetUserInfo();
  const supportWebp = isSupportWebp();

  return (
    <>
      <div className={styles.templateSelect}>
        <TagSelect
          list={tagSelect}
          active={activeTag}
          config={{
            label: "category_name",
            value: "category_name",
            icon: "category_tag",
          }}
          title="模板风格："
          onTagSelect={(v) => {
            statTrack("tools_click_ppt_home", {
              click_type: "template_style",
            });
            setActiveTag(v);
          }}
        />
      </div>
      <div className={styles.templateList}>
        {/* @ts-ignore */}
        <Scrollbars autoHide={true} className={styles.templateListScroll}>
          {templateList.map((v, index) => {
            return (
              <ItemPopover
                supportWebp={supportWebp}
                v={v}
                activeTemplate={activeTemplate}
                setActiveTemplate={setActiveTemplate}
                key={index}
              />
            );
          })}
        </Scrollbars>
      </div>
      <div className={styles.buttons}>
        <GenBtn
          uuid={BTN_UUID}
          isFree={isFromHuaweiCustom() || userInfo?.is_vip}
          className={styles.createButton}
          text="开始生成PPT"
          hideDesc={true}
          onGen={onGen}
          onErrorMessage={handleErrorMessage}
          source={SCENE}
        />
      </div>
    </>
  );
};

export default React.memo(TemplateSelect);
